import React from "react";
//#region types
import { IncomingInvoiceVouchersProps } from "models/propTypes/incomingInvoicePropTypes";
//#endregion
//#region components
import { Vouchers } from "components/voucher";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion

const IncomingInvoiceVouchers: React.FC<IncomingInvoiceVouchersProps> = (props) => {
  const incomingInvoiceService = useIncomingInvoiceService();

  return <Vouchers parentId={props.id} getVouchersHandler={incomingInvoiceService.getTransactions} />;
};

export default IncomingInvoiceVouchers;
